import { useState } from 'react';

import { FormControlGroupContext } from '../../contexts';
import {
  FormControlGroupComponentContextData,
  FormControlGroupContextData,
} from '../../contexts';

export const FormControlGroupProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [contextData, setContextData] = useState<FormControlGroupContextData>({
    state: 'default',
  });
  const setFormControlContext = (
    formControlGroupContext: FormControlGroupContextData
  ) => {
    setContextData(formControlGroupContext);
  };
  const setFormControlContextByComponent = (
    componentName: string,
    formControlContext: FormControlGroupComponentContextData
  ) => {
    setContextData((prevState) => ({
      ...prevState,
      components: {
        ...prevState.components,
        [componentName]: formControlContext,
      },
    }));
  };

  return (
    /**
     * TODO: Remove ts-ignore when we have a better solution,
     * https://github.com/i18next/react-i18next/issues/1543
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <FormControlGroupContext.Provider
      value={{
        contextData,
        setFormControlContext,
        setFormControlContextByComponent,
      }}
    >
      {children}
    </FormControlGroupContext.Provider>
  );
};
